export default function fetch(
  url = '',
  method = 'GET',
  data = {},
  async = true,
  timeout = 10000,
) {
  let xhr;
  if (window.XMLHttpRequest) {
    xhr = new XMLHttpRequest();
  } else {
    xhr = new window.ActiveXObject('Microsoft.XMLHTTP');
  }
  return new Promise((resolve, reject) => {
    xhr.open(method, url, async);
    xhr.timeout = timeout;
    xhr.onloadend = function onloadend() {
      if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
        resolve(xhr);
      } else {
        reject(
          new Error({
            errorType: 'status_error',
            xhr,
          }),
        );
      }
    };
    xhr.send(data);
    // 错误处理
    xhr.onabort = function onabort() {
      reject(
        new Error({
          errorType: 'abort_error',
          xhr,
        }),
      );
    };
    xhr.ontimeout = function ontimeout() {
      reject(
        new Error({
          errorType: 'timeout_error',
          xhr,
        }),
      );
    };
    xhr.onerror = function onerror() {
      reject(
        new Error({
          errorType: 'onerror',
          xhr,
        }),
      );
    };
  });
}
